import { performRequest, performRequestSecond, performRequestThird } from 'common/apiHandler';
import { default as apiEndPoints } from 'common/apiEndPoints';
import { FILEUPLOAD_S3, FILEUPLOAD_S3_LEVEL, SetS3Config } from 'config/amplify_config';
import { Storage } from 'aws-amplify';
import { getTenantDetails } from 'utils/utils';
import { AppConfig } from 'config/api_config';

export const getSignedUrl = async (entityFileInfo) => {
  const filePath = entityFileInfo?.file_path;
  if (!filePath) return;

  if (filePath.startsWith('public/')) {
    SetS3Config(FILEUPLOAD_S3, 'public');
    const keyWithoutPrefix = filePath.slice('public/'.length);
    try {
      return await Storage.get(keyWithoutPrefix, { useAccelerateEndpoint: true });
    } catch (err) {
      console.log(err);
    }
  }

  const [tenantId] = getTenantDetails();
  const env = process.env.REACT_APP_ENV === 'dev' ? 'develop' : process.env.REACT_APP_ENV;
  const bucket = `lawft-documents-${tenantId}-${env}`;

  Storage.configure({
    bucket,
    level: '',
    region: process.env.REACT_APP_REGION,
    identityPoolId: process.env.REACT_APP_IDP_ID,
    customPrefix: { public: '' },
  });

  try {
    return await Storage.get(filePath);
  } catch (err) {
    console.log(err);
  }
};

export const presignedURLGet = async (
  file_path,
  version_id = false,
  is_profile_image = false,
  excludeFromLoading = false,
  file_sk = '',
  file_pk = ''
) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.presignedURLGet}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&file_path=${encodeURI(file_path)}${
    version_id ? `&version_id=${version_id}` : ''
  }${is_profile_image ? `&is_profile_image=${is_profile_image}` : ''}${file_sk ? `&sk=${file_sk}` : ''}${file_pk ? `&pk=${file_pk}` : ''}`;

  try {
    return await performRequestSecond(apiEndPoints.methodType.GET, url, null, null, true, excludeFromLoading);
  } catch (error) {
    // Check if error status is 400 and retry once after 5 seconds
    if (error?.response?.status === 400) {
      await new Promise((resolve) => setTimeout(resolve, 5000));
      return performRequestSecond(apiEndPoints.methodType.GET, url, null, null, true, excludeFromLoading);
    }
    // If not 400 error, throw the original error
    throw error;
  }
};

export const downloadFolders = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  const { sk, folder_name, case_id } = data;
  return performRequestThird(
    apiEndPoints.methodType.GET,
    `${apiEndPoints.fileManager.getFolderContent}?tenant_id=${tenantId}&tenant_sk=${tenantSk}${case_id ? `&case_id=${case_id}` : ''}${
      sk ? `&sk=${sk}` : ''
    }${folder_name ? `&folder_name=${folder_name}` : ''}`
  );
};
